export function getFilterId(filter) {
    return (filter === null || filter === void 0 ? void 0 : filter.name) || "";
}
//# sourceMappingURL=getFilterId.js.map